'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const button = {
	base: "Z-6Az",
	minWidth: "xZCWw"
};
const container = "giK1x";
const content = "gmv-O";
const disabled = "Awr3R";
const icon = {
	base: "ud0td",
	left: "fZRnx",
	right: "oz3OO"
};
const overrides = {
	richTextEditor: "FKPbh",
	dropdownToggle: "FwWWQ",
	treeTableHeaderRow: "BCdYW"
};
const reverse = "i3vAh";
const size = {
	xs: "_1bJf7"
};
const type = {
	primary: "bWLLg",
	secondary: "deKgF",
	link: "-DNR-",
	"delete": "-PIEK",
	clear: "_7QzwV"
};
const typeEnum = [
	"primary",
	"secondary",
	"link",
	"delete",
	"clear"
];

exports.button = button;
exports.container = container;
exports.content = content;
exports.disabled = disabled;
exports.icon = icon;
exports.overrides = overrides;
exports.reverse = reverse;
exports.size = size;
exports.type = type;
exports.typeEnum = typeEnum;
